import { DropdownOption } from '@keplerco/core';
import { RatingAssessmentCommentsResponse } from '../../../models/overmind/assessment-analytics';
import { AssessmentSearchParams, PagingSearchParams, PermissionSearchParams, SearchingSearchParams } from '../../../models/overmind/search-params';
import { SelectedFilterOption } from '../../../pages/analytics/analytics-filters/analytics-filters.models';
import { AnalyticsFiltersOptions } from '../../../pages/analytics/assessments/assessment/assessment.models';
import { Sentiment } from '../../../enums/sentiment';

export interface RatingAssessmentCommentsSearchParams extends PagingSearchParams, AssessmentSearchParams, SearchingSearchParams {
  skillSlug?: string;
  reviewerSlug?: string;
  learnerSlug?: string;
  sentiment?: Sentiment;
}

export interface IFeedbackLayoutProps {
  isAnonymous: boolean;
  title: string;
  subtitle: string;
  data: RatingAssessmentCommentsResponse | undefined;
  isLoading: boolean;
  filtersOptions?: AnalyticsFiltersOptions;
  handleDownloadCSV: () => Promise<void>;
  handleFiltersChange: (filters: SelectedFilterOption[]) => Promise<void>;
  handleSearchQuery: (search: string) => Promise<void>;
  handlePageChange: (page: number) => Promise<void>;
  isPerson?: boolean;
}


export const sentimentOptions: DropdownOption[] = [
  { value: Sentiment.Positive.toLowerCase(), label: Sentiment.Positive },
  { value: Sentiment.Negative.toLowerCase(), label: Sentiment.Negative },
  { value: Sentiment.Neutral.toLowerCase(), label: Sentiment.Neutral },
];

export interface IFeedbackWidgetProps {
  isAnonymous: boolean;
  baseSearchParams: AssessmentSearchParams & PermissionSearchParams;
  filtersOptions?: AnalyticsFiltersOptions;
  isPerson?: boolean;
}
